__webpack_require__.p = "/wp-content/themes/bb-theme-child/assets/";